<template>
  <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 py-8">
    <!-- Başlık -->
    <div class="mb-10 px-6 md:px-0">
      <h1 class="text-2xl font-semibold text-gray-900">
        Sepetim
        <span v-if="cartStore.totalItems > 0" class="text-orange-500 text-lg">
          ({{ cartStore.totalItems }} ürün)
        </span>
      </h1>
    </div>

    <!-- Yükleniyor -->
    <div v-if="loading" class="lg:grid lg:grid-cols-12 lg:gap-8">
      <!-- Sol Kolon: Sepet Listesi Skeleton -->
      <div class="lg:col-span-8">
        <FrontendCartSkeletonList />
      </div>

      <!-- Sağ Kolon: Sepet Özeti Skeleton -->
      <div class="lg:col-span-4 mt-8 lg:mt-0">
        <FrontendCartSkeletonSummary />
      </div>
    </div>

    <!-- Sepet İçeriği -->
    <div v-else-if="cartStore.cartItems?.length > 0">
      <div class="lg:grid lg:grid-cols-12 lg:gap-8">
        <!-- Sol Kolon: Sepet Listesi -->
        <div class="lg:col-span-8">
          <FrontendCartList />
        </div>

        <!-- Sağ Kolon: Sepet Özeti -->
        <div class="lg:col-span-4 mt-8 lg:mt-0">
          <FrontendCartSummary />
        </div>
      </div>
    </div>

    <!-- Boş Sepet -->
    <div v-else class="flex flex-col items-center justify-center text-center py-12">
      <UIcon name="i-heroicons-shopping-bag" class="w-20 h-20 text-slate-300 mb-4" />
      <h3 class="text-lg font-medium text-slate-900 mb-2">Sepetiniz boş</h3>
      <p class="text-slate-500 mb-6">Sepetinizde henüz ürün bulunmuyor.</p>
      <UButton to="/" color="orange" size="lg"> Alışverişe Başla </UButton>
    </div>

  </div>
</template>

<script setup>
const cartStore = useCartStore()
const loading = ref(true)

// Sepet verilerini yükle
onMounted(async () => {
  try {
    await cartStore.fetchCartItems()
  } finally {
    loading.value = false
  }
})

await useSiteMeta()
const siteSettings = useSiteSettingsStore()
const { title: siteTitle } = storeToRefs(siteSettings)
useHead({
  title: `Alışveriş Sepetim - ${siteTitle.value}`,
  meta: [
    {
      name: 'description',
      content: 'Sepetinizdeki ürünleri inceleyin, düzenleyin ve güvenle alışverişinizi tamamlayın.'
    }
  ]
})
</script>
